module.exports = __webpack_public_path__ + "img/17.b2d80d6f.svg";